import { EntityPagerDutyCard } from './components/EntityPagerDutyCard/index.esm.js';
import 'react';
import '@backstage/plugin-catalog-react';
import './components/PagerDutySmallCard/index.esm.js';
import './components/TriggerButton/index.esm.js';

const PagerDutyCard = EntityPagerDutyCard;

export { PagerDutyCard };
//# sourceMappingURL=deprecated.esm.js.map
